/* eslint-disable react/display-name */
import * as React from 'react';
var AlertCircleFilled = React.forwardRef(function (_a, ref) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, ref: ref, viewBox: "0 0 24 24" },
        React.createElement("path", { d: "M11.984.003a12.205 12.205 0 00-8.51 3.652A11.799 11.799 0 00.002 12.21 11.778 11.778 0 0011.8 24h.214c6.677-.069 12.039-5.53 11.985-12.208A11.765 11.765 0 0011.984.003zM10.5 16.543a1.476 1.476 0 011.449-1.53h.027c.82.002 1.492.65 1.522 1.47a1.475 1.475 0 01-1.448 1.53h-.027a1.529 1.529 0 01-1.523-1.47zm.5-4.041v-6a1 1 0 012 0v6a1 1 0 01-2 0z" })));
});
export default AlertCircleFilled;
//# sourceMappingURL=AlertCircleFilled.js.map